var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-layout",
    {
      staticClass: "home-container",
      attrs: { id: "components-layout-demo-custom-trigger" },
    },
    [_c("div", {}, [_c("router-view")], 1)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }